import { z } from "zod";
import { FigmaFileStructureNodeImportModel } from "../import/figma-frames";

export const FigmaNodeStructureDataV2 = z.object({
  rootNode: FigmaFileStructureNodeImportModel,
  assetsInFile: z.object({
    components: z.number(),
    componentSets: z.number(),
    frames: z.number(),
  }),
});

export type FigmaNodeStructureDataV2 = z.infer<typeof FigmaNodeStructureDataV2>;
